/** Возвращает индекс русской формы слова для i18n. */
export const ruI18nPluralize = (choice: number, choicesLength: number): number => {
  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return choicesLength < 4 ? 2 : 3;
};

/** Возвращает legacy-форму существительного для целого числа. */
export const pluralizeRussian = (count: number, forms: readonly [string, string, string]): string => {
  const value = Math.abs(Math.trunc(count));
  const lastTwo = value % 100;
  const last = value % 10;

  if (last === 1 && lastTwo !== 11) {
    return forms[0];
  }

  if (last >= 2 && last <= 4 && (lastTwo < 10 || lastTwo >= 20)) {
    return forms[1];
  }

  return forms[2];
};
